(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["esg-report"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('esg-report-reader')) {
    customElements.define('esg-report-reader', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.pages = [...this.querySelectorAll('[data-report-page]')];
        if (!this.pages.length) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.index = 0;
        this.busy = false;
        this.dialog = this.querySelector('dialog');
        this.opener = this.querySelector('[data-open]');
        this.querySelectorAll('.esg-reader__controls').forEach(control => { control.hidden = false; });
        this.addEventListener('click', event => {
          if (this.swiped) { event.preventDefault(); this.swiped = false; return; }
          if (event.target.closest('[data-previous]')) this.showPage(this.index - 1);
          if (event.target.closest('[data-next]')) this.showPage(this.index + 1);
          if (event.target.closest('[data-close]')) this.dialog.close();
          if (event.target.closest('[data-open]')) {
            event.preventDefault();
            if (this.busy || this.dialog.open) return;
            this.renderImage(this.dialog.querySelector('[data-image]'), this.pages[this.index].content.querySelector('img'), true);
            this.previousOverflow = document.documentElement.style.overflow;
            this.dialog.showModal();
            document.documentElement.style.overflow = 'hidden';
            this.dialog.querySelector('[data-close]').focus();
          }
          if (event.target === this.dialog) {
            const bounds = this.dialog.getBoundingClientRect();
            if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
          }
        }, options);
        this.dialog.addEventListener('close', () => {
          document.documentElement.style.overflow = this.previousOverflow ?? '';
          this.opener.focus({ preventScroll: true });
        }, options);
        this.addEventListener('keydown', event => {
          if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.showPage(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, options);
        this.addEventListener('pointerdown', event => {
          this.swiped = false;
          this.touch = event.pointerType === 'touch' && event.target.closest('[data-image]') ? { x: event.clientX, y: event.clientY } : null;
        }, options);
        this.addEventListener('pointerup', event => {
          if (!this.touch) return;
          const dx = event.clientX - this.touch.x;
          const dy = event.clientY - this.touch.y;
          this.touch = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) {
            this.swiped = true;
            this.showPage(this.index + (dx < 0 ? 1 : -1));
          }
        }, options);
        this.addEventListener('pointercancel', () => { this.touch = null; }, options);
        this.addEventListener('shopify:block:select', event => {
          const index = this.pages.findIndex(page => page.dataset.blockId === event.detail.blockId);
          if (index !== -1) this.showPage(index);
        }, options);
        this.updateControls();
      }
      renderImage(target, source, large = false) {
        const image = document.importNode(source, true);
        image.loading = 'eager';
        if (large) image.sizes = '(min-width: 1500px) 1400px, 94vw';
        target.replaceChildren(image);
      }
      updateControls() {
        this.querySelectorAll('[data-counter]').forEach(counter => {
          counter.textContent = `${this.dataset.pageLabel} ${this.index + 1} / ${this.pages.length}`;
        });
        this.querySelectorAll('[data-previous]').forEach(button => { button.disabled = this.busy || this.index === 0; });
        this.querySelectorAll('[data-next]').forEach(button => { button.disabled = this.busy || this.index === this.pages.length - 1; });
        this.setAttribute('aria-busy', String(this.busy));
      }
      async showPage(index) {
        if (this.busy || index < 0 || index >= this.pages.length || index === this.index) return;
        const focusedControl = this.contains(document.activeElement) && document.activeElement.matches('[data-previous], [data-next]') ? document.activeElement : null;
        this.busy = true;
        this.updateControls();
        this.querySelectorAll('[data-error]').forEach(error => { error.hidden = true; });
        const source = this.pages[index].content.querySelector('img');
        const image = document.importNode(source, true);
        image.loading = 'eager';
        if (this.dialog.open) image.sizes = '(min-width: 1500px) 1400px, 94vw';
        let timeout;
        try {
          await Promise.race([image.decode(), new Promise((_, reject) => { timeout = setTimeout(() => reject(new Error('Image timeout')), 15000); })]);
          if (!this.isConnected) return;
          this.index = index;
          this.renderImage(this.opener.querySelector('[data-image]'), source);
          if (this.dialog.open) this.renderImage(this.dialog.querySelector('[data-image]'), source, true);
        } catch {
          if (!this.isConnected) return;
          this.querySelectorAll('[data-error]').forEach(error => { error.textContent = this.dataset.errorLabel; error.hidden = false; });
        } finally {
          clearTimeout(timeout);
          this.busy = false;
          this.updateControls();
          if (focusedControl && this.isConnected && document.activeElement === document.body) {
            const focusTarget = focusedControl.disabled ? focusedControl.parentElement.querySelector('button:not(:disabled)') : focusedControl;
            focusTarget?.focus({ preventScroll: true });
          }
        }
      }
      disconnectedCallback() {
        if (this.dialog?.open) {
          this.dialog.close();
          document.documentElement.style.overflow = this.previousOverflow ?? '';
        }
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smagsklub-signup"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', (event) => {
    if (!(event.target instanceof HTMLSelectElement) || !event.target.matches('[data-club-taste]')) return;
    const section = event.target.closest('[data-club-signup]');
    if (!section) return;
    section.querySelectorAll('[data-club-recommendation]').forEach((card) => {
      card.hidden = card.dataset.clubRecommendation !== event.target.value;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tasting-box-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const boot = function () {
    const root = document.querySelector('[data-tasting-box-catalog]');
    if (!root) return;

    const cards = Array.from(root.querySelectorAll('[data-tasting-box-card]'));
    const countEl = root.querySelector('[data-tasting-box-count]');
    const emptyEl = root.querySelector('[data-tasting-box-empty]');
    const sortToggle = root.querySelector('[data-tasting-box-sort-toggle]');
    const sortMenu = root.querySelector('[data-tasting-box-sort-menu]');
    const sortLabel = root.querySelector('[data-tasting-box-sort-label]');
    const sortOptions = Array.from(root.querySelectorAll('[data-tasting-box-sort]'));
    const grid = root.querySelector('.tasting-box-collection__grid--catalog');
    const chips = Array.from(document.querySelectorAll('[data-tasting-box-filter]'));

    const setCount = (visible) => {
      if (!countEl) return;
      const template = visible === 1 ? countEl.dataset.one : countEl.dataset.other;
      countEl.textContent = (template || String(visible)).replace('__COUNT__', String(visible));
    };

    const applyFilter = () => {
      const active = chips.find((chip) => chip.classList.contains('is-active')) || chips[0];
      const type = active ? active.dataset.tastingBoxFilter : 'all';
      const keyword = ((active && active.dataset.keyword) || '').trim().toLowerCase();
      const maxPrice = Number((active && active.dataset.maxPrice) || 0);
      let visible = 0;

      cards.forEach((card) => {
        const search = card.dataset.search || '';
        const price = Number(card.dataset.price || 0);
        const onSale = card.dataset.sale === 'true';
        let show = true;
        if (type === 'sale') show = onSale;
        else if (type === 'keyword') show = keyword === '' || search.indexOf(keyword) !== -1;
        else if (type === 'max_price') show = maxPrice > 0 && price <= maxPrice;
        card.hidden = !show;
        if (show) visible += 1;
      });

      if (emptyEl) emptyEl.hidden = visible !== 0;
      setCount(visible);
    };

    chips.forEach((chip) => {
      chip.addEventListener('click', (event) => {
        event.preventDefault();
        chips.forEach((item) => {
          const on = item === chip;
          item.classList.toggle('is-active', on);
          item.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        applyFilter();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    const applySort = (mode) => {
      if (!grid) return;
      const ordered = cards.slice().sort((a, b) => {
        if (mode === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
        if (mode === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
        return Number(a.dataset.index) - Number(b.dataset.index);
      });
      ordered.forEach((card) => grid.appendChild(card));
    };

    const positionSortMenu = () => {
      if (!sortToggle || !sortMenu || !sortMenu.matches(':popover-open')) return;
      const rect = sortToggle.getBoundingClientRect();
      const width = Math.max(sortMenu.offsetWidth, 216);
      const left = Math.min(window.innerWidth - width - 8, Math.max(8, rect.right - width));
      sortMenu.style.top = `${Math.round(rect.bottom + 6)}px`;
      sortMenu.style.left = `${Math.round(left)}px`;
    };

    const closeSortMenu = () => {
      if (sortMenu && typeof sortMenu.hidePopover === 'function' && sortMenu.matches(':popover-open')) {
        sortMenu.hidePopover();
      }
    };

    sortOptions.forEach((option) => {
      option.addEventListener('click', () => {
        const mode = option.getAttribute('data-tasting-box-sort');
        sortOptions.forEach((item) => item.setAttribute('aria-selected', item === option ? 'true' : 'false'));
        if (sortLabel) sortLabel.textContent = option.textContent.trim();
        applySort(mode);
        closeSortMenu();
      });
    });

    if (sortMenu) {
      sortMenu.addEventListener('toggle', () => {
        const open = sortMenu.matches(':popover-open');
        if (sortToggle) sortToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) requestAnimationFrame(positionSortMenu);
      });
    }
    window.addEventListener('scroll', positionSortMenu, true);
    window.addEventListener('resize', positionSortMenu);

    applyFilter();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wine-discovery-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const universes = new Set(['vin-efter-anledning', 'rodvin-paa-koel', 'vin-til-middag', 'god-vin-nemt', 'alkoholfrit-ved-bordet']);
    const query = new URLSearchParams(window.location.search);
    if (window.Shopify?.designMode || window.Shopify?.theme?.role !== 'main' || query.has('preview_theme_id') || query.has('view')) return;
    if (window.location.hostname !== 'ottosuenson.dk') return;
    const hubs = [...document.querySelectorAll('[data-discovery-tracking="true"]')].filter(hub => universes.has(hub.dataset.discoveryUniverse));
    if (!hubs.length) return;
    const exposed = new Set();
    const allowed = () => {
      try {
        return window.__ottoConsent?.analytics === true && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
      } catch (_) {
        return false;
      }
    };
    const publish = (name, data) => {
      if (!allowed() || typeof window.Shopify?.analytics?.publish !== 'function') return false;
      try {
        const result = window.Shopify.analytics.publish(name, { version: '2026-09-28.1', ...data });
        if (result && typeof result.catch === 'function') result.catch(() => {});
        return result !== false;
      } catch (_) {
        return false;
      }
    };
    hubs.forEach(hub => {
      if (hub.dataset.discoveryBound === 'true') return;
      hub.dataset.discoveryBound = 'true';
      const universe = hub.dataset.discoveryUniverse;
      const heading = hub.querySelector('.wine-discovery-hub__header');
      let visible = false;
      let timer;
      const schedule = () => {
        window.clearTimeout(timer);
        timer = undefined;
        if (!visible || document.visibilityState !== 'visible' || !allowed() || exposed.has(universe)) return;
        timer = window.setTimeout(() => {
          timer = undefined;
          if (!visible || document.visibilityState !== 'visible' || exposed.has(universe)) return;
          if (publish('otto_discovery:universe_view', { universe })) exposed.add(universe);
        }, 1000);
      };
      if (heading && typeof IntersectionObserver === 'function') {
        const observer = new IntersectionObserver(entries => {
          visible = entries.some(entry => entry.target === heading && entry.isIntersecting && entry.intersectionRatio >= 0.5);
          schedule();
        }, { threshold: [0, 0.5, 1] });
        observer.observe(heading);
        document.addEventListener('visibilitychange', schedule);
        document.addEventListener('visitorConsentCollected', schedule);
        document.addEventListener('otto:consent-ready', schedule);
        window.addEventListener('pagehide', () => {
          visible = false;
          window.clearTimeout(timer);
          observer.disconnect();
        });
        window.addEventListener('pageshow', event => {
          if (event.persisted) observer.observe(heading);
        });
      }
      const productClick = event => {
        if (event.defaultPrevented || !event.isTrusted || (event.type === 'auxclick' && event.button !== 1)) return;
        if (document.visibilityState !== 'visible' || !allowed()) return;
        const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
        const card = link?.closest('[data-discovery-product]');
        if (!card || !hub.contains(card)) return;
        const url = new URL(link.href, window.location.origin);
        if (url.origin !== window.location.origin || !/^\/products\/[^/]+\/?$/.test(url.pathname)) return;
        const product = card.dataset.discoveryProduct;
        const selection = card.dataset.discoverySelection;
        const position = Number(card.dataset.discoveryPosition);
        if (!/^[1-9]\d{0,19}$/.test(product || '') || !/^[\w-]{1,64}$/.test(selection || '') || !Number.isInteger(position) || position < 1 || position > 12) return;
        publish('otto_discovery:product_click', { universe, product_id: product, selection, position });
      };
      hub.addEventListener('click', productClick);
      hub.addEventListener('auxclick', productClick);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
